import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import { FormattedMessage } from 'react-intl';
import CheckboxInput from 'components/Credit24/Core/Controls/CheckboxInput';
import { upgradeLoansData } from 'consts/loan/AU';
import LoanSection from './LoanSection';

const propTypes = {
  loanPaymentsFrequencies: PropTypes.array.isRequired,
  loanTypes: PropTypes.array.isRequired,
  hasCreditCards: PropTypes.bool,
  hasLoans: PropTypes.bool,
  hasSmallLoans: PropTypes.bool,
};

const UpgradeLoansAU = (props) => {
  const { loanPaymentsFrequencies, loanTypes } = props;

  return (
    <>
      {upgradeLoansData
        .filter((section) => {
          if (section.dependsOn) {
            return props[section.dependsOn];
          }
          return true;
        })
        .map((section) => (
          <LoanSection
            key={section.name}
            {...section}
            hasFlag={props[section.hasFlagProp]}
            loanTypes={loanTypes}
            paymentFrequencies={loanPaymentsFrequencies}
          />
        ))}
      <br />
      <Field
        name="creditBureauEnquiries"
        component={CheckboxInput}
        text={<FormattedMessage id="loans.field.creditBureauEnquiries.upgrade" />}
      />
    </>
  );
};

UpgradeLoansAU.propTypes = propTypes;

export default UpgradeLoansAU;
